import { render, staticRenderFns } from "./folders-counterparties-payments.vue?vue&type=template&id=723f58c0&scoped=true"
import script from "./folders-counterparties-payments.vue?vue&type=script&lang=js"
export * from "./folders-counterparties-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723f58c0",
  null
  
)

export default component.exports